import Dexie from 'dexie';
import { DexieDBOptions } from './db.if';

class DexieDB extends Dexie {
    constructor(options: DexieDBOptions = {}) {
        if (!options.IDBKeyRange) {
            options.IDBKeyRange = IDBKeyRange;
        }

        if (!options.indexedDB) {
            options.indexedDB = indexedDB;
        }

        const name = options.name ?? 'Workspace-DB';

        super(name, options);

        this.version(options.version ?? 1).stores(options.mappings ?? {});
    }
}

export default DexieDB;
